'use strict';

angular
  .module('appSettingInviteCoupon')
  .component('appSettingInviteCoupon', {
    template: require('./invite-coupon.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService',
      function AppSettingInviteCouponController($rootScope, $resource, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'appSetting';
        $rootScope.menu = 'inviteCoupon';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.canEditAppSettings();
        this.saving = false;
        this.countries = ['TH', 'KR', 'JP'];
        this.textLocales = ['en', 'th', 'ko', 'ja'];
        const memberCountry = (this.loginMember && this.loginMember.COUNTRY_CODE)
          ? String(this.loginMember.COUNTRY_CODE).toUpperCase()
          : 'TH';
        this.country = this.countries.indexOf(memberCountry) >= 0 ? memberCountry : 'TH';
        this.productTypes = [
          { value: 'platinum', label: 'Ultra' },
          { value: 'gold', label: 'Pro' },
          { value: 'silver', label: 'Ex' },
          { value: 'pearl', label: 'Pure' },
          { value: 'all package', label: 'All Package' },
        ];
        this.placeholderHint = '{inviteProduct} {invitePercent} {invite} {rewardProduct} {rewardPercent} {reward} {rewardPoint} {name} {code} {link} {months}';

        // App copy language = top-right admin language only (no country / page language tabs).
        this._resolveTextLang = () => {
          let saved = null;
          try { saved = window.localStorage.getItem('omgAdminLang'); } catch (e) { saved = null; }
          const raw = String(
            saved
            || $translate.use()
            || $translate.proposedLanguage()
            || 'en'
          ).slice(0, 2).toLowerCase();
          if (raw === 'jp') return 'ja';
          if (this.textLocales.indexOf(raw) >= 0) return raw;
          return 'en';
        };
        this.textLang = this._resolveTextLang();
        this.textLangLabel = () => {
          const map = { en: 'EN', th: 'TH', ko: 'KO', ja: 'JA' };
          return map[this.textLang] || String(this.textLang || '').toUpperCase();
        };
        $rootScope.$on('$translateChangeSuccess', () => {
          this.textLang = this._resolveTextLang();
          if (this.isLevel2Auth) {
            this.fillDefaults(false);
          }
        });

        this._normalizePercent = (value) => {
          const n = Number(value);
          if (!Number.isFinite(n) || n < 0) return 0;
          return Math.min(100, Math.round(n));
        };

        this._emptyTexts = () => ({
          menu_name: '',
          txt1: '',
          txt1_bold: '',
          txt2: '',
          txt3: '',
          txt4: '',
          share_msg: '',
        });

        this._emptyTextsByLocale = () => {
          const out = {};
          this.textLocales.forEach((lang) => {
            out[lang] = this._emptyTexts();
          });
          return out;
        };

        this.textDefaults = this._emptyTextsByLocale();

        this._normalizeTexts = (raw) => {
          const out = this._emptyTextsByLocale();
          const src = raw || {};
          this.textLocales.forEach((lang) => {
            out[lang] = Object.assign(this._emptyTexts(), src[lang] || {});
          });
          return out;
        };

        this._normalizeRow = (raw) => {
          const src = raw || {};
          return {
            type: String(src.type || 'PERCENT').toUpperCase() === 'NORMAL' ? 'NORMAL' : 'PERCENT',
            reg_product_type: src.reg_product_type || 'platinum',
            reg_percent: this._normalizePercent(src.reg_percent != null ? src.reg_percent : 50),
            invite_product_type: src.invite_product_type || 'platinum',
            invite_percent: this._normalizePercent(src.invite_percent != null ? src.invite_percent : 50),
            reward_product_type: src.reward_product_type || 'platinum',
            reward_percent: this._normalizePercent(src.reward_percent != null ? src.reward_percent : 50),
            texts: this._normalizeTexts(src.texts),
          };
        };

        this.rows = {
          TH: this._normalizeRow(null),
          KR: this._normalizeRow(null),
          JP: this._normalizeRow(null),
        };

        this.currentTexts = () => {
          const row = this.rows[this.country];
          if (!row || !row.texts) return this._emptyTexts();
          if (!row.texts[this.textLang]) {
            row.texts[this.textLang] = this._emptyTexts();
          }
          return row.texts[this.textLang];
        };

        this.previewMenu = () => {
          const texts = this.currentTexts();
          if (texts.menu_name && String(texts.menu_name).trim()) {
            return texts.menu_name;
          }
          const defaults = this.textDefaults[this.textLang] || {};
          if (defaults.menu_name) return defaults.menu_name;
          const row = this.rows[this.country] || this._normalizeRow(null);
          const product = this.productTypes.find((p) => p.value === row.reward_product_type);
          const name = product ? product.label : (row.reward_product_type || '');
          return `Get ${name} ${row.reward_percent}% Off coupon`;
        };

        this.fieldPlaceholder = (key) => {
          const defaults = this.textDefaults[this.textLang] || {};
          return defaults[key] || '';
        };

        this.fillDefaults = (force) => {
          const lang = this.textLang;
          const defaults = this.textDefaults[lang] || this._emptyTexts();
          const texts = this.currentTexts();
          Object.keys(defaults).forEach((k) => {
            if (force || !texts[k] || !String(texts[k]).trim()) {
              texts[k] = defaults[k] || '';
            }
          });
        };

        this.load = () => {
          $resource(`${APIURL}/admin/services/apps/settings`)
            .get()
            .$promise
            .then((data) => {
              const defaults = (data && data.invite_text_defaults) || {};
              this.textLocales.forEach((lang) => {
                this.textDefaults[lang] = Object.assign(this._emptyTexts(), defaults[lang] || {});
              });
              const invite = (data && data.invite_coupon) || {};
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(invite[code]);
              });
              if (this.isLevel2Auth) {
                this.fillDefaults(false);
              }
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.save = () => {
          if (!this.isLevel2Auth) {
            return;
          }
          if (!confirm($translate.instant('초대 쿠폰 설정을 저장하시겠습니까?'))) {
            return;
          }
          this.saving = true;
          const invite_coupon = {};
          this.countries.forEach((code) => {
            invite_coupon[code] = this._normalizeRow(this.rows[code]);
          });
          const Res = $resource(`${APIURL}/admin/services/apps/settings`, {}, {
            update: { method: 'PUT' },
          });
          Res.update({ invite_coupon })
            .$promise
            .then((data) => {
              const invite = (data && data.invite_coupon) || invite_coupon;
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(invite[code]);
              });
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            })
            .finally(() => {
              this.saving = false;
            });
        };

        this.load();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/app-setting/invite-coupon/invite-coupon.component.js